import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { AzureCosmosCopySource } from 'app/model/pipeline/copysource/azure-cosmos.copysource';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureCosmosCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*',
        nestingSeparator: '*'
    }
})
export class AzureCosmosCopySourceAdapter extends CopySourceAdapter<
    AzureCosmosCopySource,
    Model.DocumentDbCollectionSource
> {
    protected override async _toResource(copySource: AzureCosmosCopySource): Promise<Model.DocumentDbCollectionSource> {
        const result: Model.DocumentDbCollectionSource = this.getCommonCopySourceProperties(
            copySource,
            'DocumentDbCollectionSource'
        );
        if (copySource.mode === 'query') {
            result.query = ValueAdapter.toResource(copySource, AzureCosmosCopySource.READER_QUERY);
        }
        result.nestingSeparator = ValueAdapter.toResource(copySource, AzureCosmosCopySource.NESTING_SEPARATOR);
        return result;
    }

    protected override async _toModel(
        resource: Model.DocumentDbCollectionSource,
        copyActivity: CopyActivity
    ): Promise<AzureCosmosCopySource> {
        const result = this.createCopySourceWithCommonProperties(
            AzureCosmosCopySource.MODEL,
            resource,
            copyActivity
        ) as AzureCosmosCopySource;
        if (resource.query) {
            ValueAdapter.toModel(result, AzureCosmosCopySource.READER_QUERY, resource.query);
            result.mode = 'query';
        }
        ValueAdapter.toModel(result, AzureCosmosCopySource.NESTING_SEPARATOR, resource.nestingSeparator);
        return result;
    }
}
